import { InjectionToken } from '@angular/core';
import { PriceKind, SelectedPrice } from '@product/const';

// В компоненте sd-item-counter есть обязательный параметр selectedPrice, хардкодим его
export const BETON_PRICE_DATA = new InjectionToken<SelectedPrice>('beton price data', {
  factory: (): SelectedPrice => {
    return {
      kind: PriceKind.REGULAR,
      unit: {
        code: 'м³',
        name: 'м³',
        ratio: 1,
      },
      saleUnit: {
        code: 'м³',
        name: 'м³',
        ratio: 1,
      },
      minValue: 0.5,
      multiplicity: 0.5,
      orderMinimum: 0.5,
    };
  },
});
